import { useEffect } from 'react'

import { Layout } from '../../components'
import { UserManagementPanel } from '../../components/panels'
import { DRAWER_KEYS } from '../../store/constants'

import AuthPage from './AuthPage'

/**
 * @description Renders the UserManagementPage component.
 * The component is wrapped in the AuthPage component to ensure that the user is authenticated before accessing the page.
 * 
 * @author Paulo Victor Borges
 * @returns {JSX.Element} The rendered UserManagementPage component.
 */
const UserManagementPage = () => {

    useEffect(() => {
        document.title = 'Gerenciamento de Usuários | LCD'
    }, [])

    return (
        <AuthPage>
            <Layout selectedKey={DRAWER_KEYS.USERS}>
                <UserManagementPanel />
            </Layout>
        </AuthPage>
    )
}

export default UserManagementPage